"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createConnect_1 = require("./createConnect");
exports.default = createConnect_1.default({
    field: 'meta:sort',
    mapProps: function (props) { return ({
        selected: props && props.get(0),
    }); },
    handlers: {
        onChangeSort: function (_a) {
            var update = _a.update;
            return function (field, order) {
                return !field || field === 'default'
                    ? update('sort')
                    : update('sort', [{ field: field, order: order }]);
            };
        }
    }
});
//# sourceMappingURL=connectSort.js.map